import {
  fontCSS,
  filledOutlineShadow,
  defaultState,
  errorState,
  focusedState,
  disabledState,
  readOnlyState
} from 'components/v2/common.styled';
import styled, { css } from 'styled-components';

import { Status } from '../../types';

export const Container = styled.div`
  position: relative;
`;

export const Placeholder = styled.span<{ $status: Status }>`
  ${fontCSS}
  line-height: 24px;
  color: ${defaultState.placeholderColor};

  ${({ $status }) => {
    if ($status === 'error') {
      return css`
        color: ${errorState.textColor};
      `;
    }

    if ($status === 'disabled') {
      return css`
        color: ${disabledState.textColor};
      `;
    }

    if ($status === 'readOnly') {
      return css`
        color: ${disabledState.textColor};
      `;
    }
  }}
`;

export const SelectedOption = styled.div<{
  $isDropDownOpened: boolean;
  $status: Status;
  $isFilled: boolean;
}>`
  display: flex;
  align-items: center;
  line-height: 24px;
  padding: 20px 24px;
  cursor: pointer;
  ${fontCSS}
  color: ${defaultState.textColor};
  background-color: ${defaultState.backgroundColor};
  border-radius: ${defaultState.borderRadius};
  box-shadow:
    0px 1px 3px 0px rgba(67, 71, 146, 0.16),
    0px 1px 1px 0px rgba(10, 13, 61, 0.08);

  ${({ $isDropDownOpened }) =>
    $isDropDownOpened &&
    css`
      box-shadow: ${focusedState.boxShadow};
    `}

  ${({ $isFilled, $isDropDownOpened }) =>
    $isFilled &&
    !$isDropDownOpened &&
    css`
      box-shadow: ${filledOutlineShadow};
    `}

  ${({ $status }) => {
    if ($status === 'error') {
      return css`
        color: ${errorState.textColor};
        border-style: ${errorState.borderStyle};
        border-color: ${errorState.borderColor};
        border-width: ${errorState.borderWidth};
        box-shadow: ${errorState.boxShadow};
      `;
    }

    if ($status === 'disabled') {
      return css`
        color: ${disabledState.textColor};
        background: ${disabledState.backgroundColor};
        border-style: ${disabledState.borderStyle};
        border-color: ${disabledState.borderColor};
        border-width: ${disabledState.borderWidth};
        cursor: ${disabledState.cursor};
      `;
    }

    if ($status === 'readOnly') {
      return css`
        color: ${readOnlyState.textColor};
        background: ${readOnlyState.backgroundColor};
        border-style: ${readOnlyState.borderStyle};
        border-color: ${readOnlyState.borderColor};
        border-width: ${readOnlyState.borderWidth};
        cursor: ${readOnlyState.cursor};
      `;
    }
  }}
`;

export const SelectedOptionLabel = styled.span<{ $wrapSelectedOptionText?: boolean }>`
  flex: 1;
  ${({ $wrapSelectedOptionText }) => {
    if ($wrapSelectedOptionText) {
      return css`
        white-space: wrap;
      `;
    }

    return css`
      white-space: nowrap;
    `;
  }}

  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ArrowIcon = styled.div`
  padding: 0 16px;

  svg {
    width: 12px;
    fill: ${defaultState.sideIconFillColor};
  }
`;
